export class Media {

    constructor(item: Media | void) {
        if(item instanceof Object) {
            this.file = item.file;
            this.name = item.name;
        }
    }

    file: any[] = [];
    name: string = "";
}
